import { useGetPAnalysisCellsQuery } from '@report/graphql';
import { Flex, Text } from '@shared/components';
import { useDisclosure } from '@shared/hooks';

import { PAnalysisSectionTitle, PValuesAdjustmentButton } from '../../components';
import { useItemAnalysisSearchParams } from '../../hooks';
import { getDifficultyLevelDiffCount } from '../../utils';
import { PValuesAdjustmentConfirmationModal } from '../p-values-adjustment-confirmation-modal';

export default function PAnalysisSection() {
  const [
    isPValuesAdjustmentConfirmationModalOpen,
    {
      open: openPValuesAdjustmentConfirmationModal,
      close: closePValuesAdjustmentConfirmationModal,
    },
  ] = useDisclosure();

  const handleAdjustPValues = () => {
    openPValuesAdjustmentConfirmationModal();
  };

  const [
    {
      startDate,
      endDate,
      examCourse,
      minExaminees,
      pBufferEasyThreshold,
      pBufferHardThreshold,
      pBufferMediumThreshold,
    },
  ] = useItemAnalysisSearchParams();

  const isFilterSet = !!startDate && !!endDate && !!examCourse && minExaminees !== null;

  const { data: pAnalysisCellsData } = useGetPAnalysisCellsQuery({
    skip: !isFilterSet,
    variables: {
      getPAnalysisCellsInput: {
        startedAt: startDate as Date,
        endedAt: endDate as Date,
        qBankStructureId: examCourse as string,
        minimumExamineePerQuestion: minExaminees as number,
        pValueCustomThreshold: {
          hard: {
            min: 0,
            max: pBufferHardThreshold,
          },
          medium: {
            min: Number(pBufferHardThreshold + 0.01),
            max: pBufferMediumThreshold,
          },
          easy: {
            min: Number(pBufferMediumThreshold + 0.01),
            max: pBufferEasyThreshold,
          },
        },
      },
    },
  });

  const pAnalysisCells = pAnalysisCellsData?.reportGetPAnalysisCells.cells ?? [];

  const difficultyLevelDiff = getDifficultyLevelDiffCount(pAnalysisCells);
  const totalDiffCount =
    difficultyLevelDiff.oneLevelDiffCount + difficultyLevelDiff.twoLevelDiffCount;

  return (
    <Flex sx={{ flexDirection: 'column' }}>
      <PAnalysisSectionTitle
        endAdornment={
          <Flex sx={{ gap: (theme) => theme.spacing(3), alignItems: 'center' }}>
            <Text variant='body2'>รายการที่สามารถบันทึกได้: {totalDiffCount} ข้อ</Text>
            <PValuesAdjustmentButton
              disabled={!isFilterSet || totalDiffCount === 0}
              onClick={handleAdjustPValues}
            />
          </Flex>
        }
      />
      <PValuesAdjustmentConfirmationModal
        open={isPValuesAdjustmentConfirmationModalOpen}
        onClose={closePValuesAdjustmentConfirmationModal}
      />
    </Flex>
  );
}
